module.exports = __webpack_public_path__ + "static/media/ic_undo_selected.d814b5a2.svg";